<template>
  <div>
    <v-row class="pt-6 align-item-s" v-if="educations && educations.length">
      <v-col xs="12" sm="12" lg="6" v-for="(item, index) in educations" :key="'row_' + index">
        <EducationItem :education="item" @edit="edit(item)" @remove="remove(item)" :isHiringmanager="isHiringmanager" />
        <!-- <div class="card-list-component">
          <div class="icon-section">
            <v-icon>mdi-school</v-icon>
          </div>
          <div class="details-section">
            <div class="title-section">
              <h2 class="title">{{ item.University }}</h2>
              <div class="action-section">
                <v-btn v-if="!isHiringmanager" fab small icon @click="edit(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn v-if="!isHiringmanager" fab small icon @click="remove(item)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
            </div>
            <div>{{ item.Degree }}</div>
            <div class="bottom-section">
              <div class="left-text">
                {{ item.StudyField }} {{ item.StartDate ? " | " + item.StartDate.getFullYear() : "" }}
                {{ item.EndDate ? " - " + item.EndDate.getFullYear() : "" }}
              </div>
              <div class="still-studying" v-if="item.StillStudying">Still Studying</div>
            </div>
          </div>
        </div> -->
      </v-col>
    </v-row>
    <v-row v-else class="pt-16 pb-16 mt-16">
      <v-col class="text-center">
        <h2>You can see added educations here</h2>
      </v-col>
    </v-row>
  </div>
</template>
<script lang="ts">
import { Education } from "../../../models/Teammember";
import Utils from "../../../utils/Utils";
import { defineComponent } from "vue";
import EducationItem from "./EducationItem.vue";

export default defineComponent({
  props: ["skills", "educationList", "addLoading", "isHiringmanager"],
  components: { EducationItem },
  data() {
    return {
      educations: [] as Education[],
      loading: false,
    };
  },
  methods: {
    edit(item: any) {
      this.$emit("edit", item);
    },
    remove(item: any) {
      this.$emit("remove", item);
    },
    formatDate(value: any): string {
      if (value) {
        return `${Utils.toVsDateFormat(value)}`;
      } else {
        return "";
      }
    },
  },
  watch: {
    addLoading(newVal) {
      this.loading = newVal;
    },
    educationList(newVal) {
      this.educations = newVal;
    },
  },

  mounted() {
    this.educations = [...this.educationList];
  },
});
</script>
